import React, { useEffect, useState } from 'react';
import SortableList, { SortableItem } from 'react-easy-sort';
import { arrayMoveImmutable } from 'array-move';
import { Form, message } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { surveyApis } from 'apis/operation/surveyApis';
import { AnswerCheckType, answerTypeList } from 'utils/constant';
import CircleButton from 'components/button/CircleButton';
import Message from 'components/etc/Message';
import SmallModal from 'components/form/SmallModal';
import VerticalForm from 'components/form/DefaultForm';
import DefaultInput from 'components/input/DefaultInput';
import DefaultRadio from 'components/input/DefaultRadio';
import DefaultSelect from 'components/select/DefaultSelect';
import { arrayMove } from 'react-sortable-hoc';
import SubmitButton from 'components/button/SubmitButton';
import { useTranslation } from 'react-i18next';

const QuestionInputModal = ({
  visible,
  setVisible,
  fetchData,
  surveyRecord,
  record,
}) => {
  const { t } = useTranslation();
  const answerCheckType = AnswerCheckType();
  const [isSorted, setIsSorted] = useState(false);
  const [answerList, setAnswerList] = useState([
    {
      answer: null,

      key: 0,
    },
  ]);
  //등록시 필요
  const [inputData, setInputData] = useState({
    question_id: 0, //
    question: null,
    answer_kind: 0,
    select_check: 0,
  });

  const onSortEnd = async (oldIndex, newIndex) => {
    setAnswerList((v) => arrayMove(v, oldIndex, newIndex));
    setIsSorted(true);

    const newData = arrayMoveImmutable(
      [].concat(answerList),
      oldIndex,
      newIndex,
    ).filter((el) => !!el);

    let sortData = newData.map((v, i) => {
      v.id = v.answer_id;
      v.key = i;
      return v;
    });

    // console.log(sortData, '<sort');
    setAnswerList(sortData);

    // const res = await surveyApis.answerSorting(surveyRecord, sortData);
  };

  const handleSelectChange = (e, p) => {
    console.log(e, p);
    setInputData({ ...inputData, [p.name]: e });
  };

  const handleInputChange = (e) => {
    let { name, value, checked } = e.target;
    if (name === 'exception_country') {
      // inputData.exception_country.replace(/ /g, '');
      setInputData({
        ...inputData,
        [name]: value.toUpperCase().replace(/ /g, ''),
      });
    } else if (name === 'is_public') {
      setInputData({ ...inputData, [name]: checked === true ? 1 : 0 });
    } else {
      setInputData({ ...inputData, [name]: value });
    }
  };
  //답변 리스트 inputChange
  const handleAnswerChange = (e) => {
    // console.log(e.target.id);
    setAnswerList(
      answerList.map((v, i) =>
        v.key === Number(e.target.id) ? { ...v, answer: e.target.value } : v,
      ),
    );
  };

  //답변 리스트 행 삭제
  const handleRemoveRow = (e) => {
    if (answerList.length === 1) {
      return false;
    }

    const newDatas = [...answerList];
    const idx = newDatas.findIndex(function (item) {
      return item.key === Number(e.target.name);
    });
    newDatas.splice(idx, 1);
    newDatas.map((v, i) => (v.key = i)); // id 값을 다시 인덱스대로 돌리기 위해
    setAnswerList(newDatas);
  };
  // 답변 리스트 행 추가
  const handleAddRow = (e) => {
    const newDatas = [
      ...answerList,
      {
        answer: null,
        key: answerList.length,
      },
    ];
    setAnswerList(newDatas);
  };

  const handleSubmit = async () => {
    const res = await surveyApis.questionUpdate(
      surveyRecord,
      inputData,
      answerList,
    );
    if (record && isSorted) {
      const sortAnswerRes = await surveyApis.answerSorting(
        surveyRecord,
        answerList,
      ); //정렬을 submit때 보내줌
      if (!sortAnswerRes) {
        return false;
      }
    }
    if (!res) {
      return false;
    }
    fetchData();
    setVisible(false);
    message.success(
      `${surveyRecord?.title_text}항목의 질문이 ${
        record ? '수정' : '추가'
      }되었습니다.`,
    );
  };

  const fetchInputData = async () => {
    const res = await surveyApis.surveyDetail(
      surveyRecord.survey_id,
      record.question_id,
    );
    setInputData(res.question[0]);
    res.answer.map((v, i) => {
      v.key = i;
    });
    setAnswerList(res.answer);
  };

  useEffect(() => {
    fetchInputData().catch(console.log);
  }, []);

  return (
    <SmallModal
      footer={
        <SubmitButton onClick={handleSubmit}>
          {record
            ? t('survey.table.nestBody.questionInputModal.editButton')
            : t('survey.table.nestBody.questionInputModal.registerButton')}
        </SubmitButton>
      }
      title={`${t('survey.table.nestBody.questionInputModal.questionTitle')} ${
        record
          ? t('survey.table.nestBody.questionInputModal.editTile')
          : t('survey.table.nestBody.questionInputModal.addTtile')
      }`}
      visible={visible}
      onCancel={setVisible}
      fetchData={fetchData}
      top={'5rem'}
    >
      <VerticalForm>
        <div className='title_wrap' style={{ marginBottom: '1rem' }}>
          <p>{t('survey.table.nestBody.questionInputModal.addQuestion')} :</p>
          <span>{surveyRecord?.title_text}</span>
        </div>
        <Form.Item
          label={t('survey.table.nestBody.questionInputModal.question')}
        >
          <div style={{ display: 'flex' }}>
            <DefaultInput
              width={'10rem'}
              value={inputData.question}
              name='question'
              type='number'
              onChange={handleInputChange}
              placeholder={t(
                'survey.table.nestBody.questionInputModal.multilingualID',
              )}
            />
            <Message width={'30rem'} value={record?.question_text} />
          </div>
        </Form.Item>
        <Form.Item
          label={t('survey.table.nestBody.questionInputModal.answerType')}
        >
          <DefaultSelect
            optionList={answerTypeList}
            showSearch={false}
            value={inputData?.answer_kind}
            onChange={handleSelectChange}
            name='answer_kind'
          />
        </Form.Item>
        <Form.Item
          label={t('survey.table.nestBody.questionInputModal.multipleChoice')}
        >
          <DefaultRadio
            name='select_check'
            onChange={handleInputChange}
            optionList={answerCheckType}
            defaultValue={
              inputData?.answer_kind === 1 ? 0 : inputData.select_check
            }
            disabled={inputData?.answer_kind === 1 && true}
          />
        </Form.Item>
        {inputData?.answer_kind === 0 && (
          <SortableList
            onSortEnd={onSortEnd}
            draggedItemClassName='dragged'
            className='list'
          >
            <Form.Item
              label={t('survey.table.nestBody.questionInputModal.addAnswer')}
            >
              {answerList?.map((v, i) => (
                <SortableItem key={v}>
                  <div
                    className='item'
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '.5rem',
                    }}
                  >
                    <MenuOutlined
                      style={{
                        cursor: 'pointer',
                        color: '#999',
                        padding: '.5rem',
                      }}
                    />
                    <DefaultInput
                      width={'10rem'}
                      type='number'
                      value={v.answer}
                      id={i}
                      onChange={handleAnswerChange}
                      placeholder={t(
                        'survey.table.nestBody.questionInputModal.multilingualID',
                      )}
                    />
                    <Message value={v.answer_text} width={'30rem'} />
                    <div style={{ display: 'flex' }}>
                      <CircleButton
                        disabled={answerList.length === 1 && true}
                        style={{ marginLeft: '1rem' }}
                        name={i}
                        onClick={handleRemoveRow}
                      >
                        -
                      </CircleButton>
                      <CircleButton
                        disabled={answerList.length === 10 && true}
                        style={{ marginLeft: '1rem' }}
                        key={i}
                        onClick={handleAddRow}
                      >
                        +
                      </CircleButton>
                    </div>
                  </div>
                </SortableItem>
              ))}
            </Form.Item>
          </SortableList>
        )}
      </VerticalForm>
    </SmallModal>
  );
};
export default QuestionInputModal;
